(function(){
var L=window.TCGB,m=L.m,e=L.e,sz=L.sz,GIFT=L.GIFT,get=L.get,look=L.look,coll=L.coll;

function init(root){
if(root.dataset.tcgbReady)return;root.dataset.tcgbReady='1';
var d=root.dataset,C={jar:(d.jarCollections||'').split(',').filter(Boolean),mid:(d.midCollections||'').split(',').filter(Boolean),
ext:(d.extraCollections||'').split(',').filter(Boolean),box:(d.boxVariant||'').trim(),
box2:(d.boxVariant2||'51523747840167').trim(),wv:(d.wrapVariant||'').trim(),
ship:Math.round(parseFloat(d.freeShip||'0')*100),al:d.allLabel||'All',
pl:d.preorderLabel||'Pre-order · ships 1 Nov',
mt:d.midTitle||'Centrepiece',ms:d.midSub||'',mc:d.midCta||'Add',mk:d.midSkip||'Later',
xt:d.extTitle||'One more thing?',xn:d.extNote||'',xc:d.extCta||'Add',xk:d.extSkip||'No thanks',
wt:d.wrapTitle||'Gift wrap?',wn:d.wrapNote||'',wy:d.wrapYes||'Yes please',wx:d.wrapNo||'No thanks',
xoff:Math.max(0,Math.min(100,parseFloat(d.extraDiscount||'30')||0))/100,
xmax:parseInt(d.extraDiscountMax||'2',10)||0,
xfine:(d.extraFine||'')};

/* Extras upsell copy — built from the numbers above unless overridden */
if(!C.xfine&&C.xoff>0)C.xfine='Applied automatically at checkout. Discounts can’t be combined with other offers.';
C.xbar=d.extraBar||(C.xoff>0?('<b>Gift box exclusive</b> · '+Math.round(C.xoff*100)+'% off '
+(C.xmax>0?'up to '+C.xmax+' extra'+(C.xmax>1?'s':''):'your extras')):'');

/* Format filters, read off the variant labels */
var FMT={'f:tea':{re:/^loose leaf/i,label:'Tea'},
'f:bags':{re:/tea bags/i,label:'Tea Bags'},
'f:soak':{re:/bath soak/i,label:'Bath Soaks'}};
/* Style chips that are too thin on their own get shown together */
var GRP={'Whites & Oolongs':['White','Oolong','Oolong Blends']};

var ins='three',jars=[],mid=null,exs=[],wrap=false,pk={},A=[],M=[],X=[];
var chip='all',term='',bv=0,bv2=0,wp=0,wi='',ma=false,xa=false,wa=false,cur='';
function q(s){return root.querySelector(s)}
var el={g:q('[data-jar-grid]'),ch:q('[data-chips]'),se:q('[data-search]'),sl:q('[data-slots]'),jc:q('[data-jar-count]'),
sb:q('[data-subtotal]'),sr:q('.tcgb__totals-save'),sv:q('[data-saving]'),bx:q('[data-box-value]'),
sh:q('[data-ship]'),sf:q('[data-ship-fill]'),st:q('[data-ship-text]'),cta:q('[data-add]'),ct:q('[data-cta-text]'),
er:q('[data-err]'),nt:q('[data-note]'),lk:q('[data-links]'),bi:q('[data-bar-info]'),bc:q('[data-bar-add]'),
bt:q('[data-bar-text]'),mo:q('[data-modal]'),mb:q('[data-modal-box]')};

function mx(){return ins==='three'?3:2}
function full(){return jars.length>=mx()}
function done(){return full()&&(ins!=='two'||mid)}
function boxV(){return (ins==='two'&&C.box2)?C.box2:C.box}

Promise.all(C.jar.map(get)).then(function(p){A=coll(p,true);chips();grid();draw()});
if(C.mid.length)Promise.all(C.mid.map(get)).then(function(p){M=coll(p,false);draw()});
if(C.ext.length)Promise.all(C.ext.map(get)).then(function(p){X=coll(p,false);draw()});

function sd(i){var s=i.o.filter(function(o){return !GIFT.test(o.raw)});return s.length?s:i.o}
function op(i){var v=pk[i.id],s=sd(i),f=null;s.forEach(function(o){if(String(o.id)===String(v))f=o});return f||s[0]}
function gf(i,o){var g=i.o.filter(function(x){return GIFT.test(x.raw)});if(!g.length)return null;
if(g.length===1&&sd(i).length===1)return g[0];
var w=(o.label||'').toLowerCase(),h=null;
g.forEach(function(x){if(w&&x.raw.toLowerCase().indexOf(w)!==-1)h=x});return h||g[0]}
function use(i){var o=op(i),g=gf(i,o);return (g&&done()&&g.price<o.price)?g:o}
function inJ(id){return jars.some(function(j){return String(j.pid)===String(id)})}
function inX(id){return exs.some(function(x){return String(x.pid)===String(id)})}
function mk(i,o){return {pid:i.id,vid:o.id,title:i.title,label:o.label,price:o.price,img:i.img,pre:i.pre}}
function sync(){exs=exs.map(function(x){var i=X.filter(function(y){return String(y.id)===String(x.pid)})[0];
return i?mk(i,use(i)):x})}
function find(id){return A.concat(M,X).filter(function(i){return String(i.id)===String(id)})[0]}
function anyPre(){var r=jars.slice();if(mid)r.push(mid);exs.forEach(function(x){r.push(x)});
return r.some(function(x){return x&&x.pre})}

/* Extras discount. Shopify applies it as an automatic Buy-X-Get-Y on the cart,
   so this is display only — subtract the rounded discount, never the rounded price. */
function xDisc(p){return C.xoff>0?Math.max(0,p-Math.round(p*C.xoff)):p}
function xCap(i){return C.xmax<=0||i<C.xmax}
function xEff(x,i){return xCap(i)?xDisc(x.price):x.price}

function hasFmt(i,k){var r=FMT[k].re;return i.o.some(function(o){return r.test(o.label||'')})}
function fmtAny(k){return A.some(function(i){return hasFmt(i,k)})}
function grpOf(t){var g;for(g in GRP){if(GRP[g].indexOf(t)!==-1)return g}return t}

function chips(){var t={},k,list=['all'],skip={};
A.forEach(function(i){t[grpOf(i.type)]=true});
for(k in FMT){if(fmtAny(k))list.push(k)}
for(k in FMT){skip[FMT[k].label.toLowerCase().replace(/s$/,'')]=1}
list=list.concat(Object.keys(t).filter(function(x){
return x&&!skip[String(x).toLowerCase().replace(/s$/,'')]}).sort());
el.ch.innerHTML=list.map(function(x){
var lab=x==='all'?C.al:(FMT[x]?FMT[x].label:x);
return '<button type="button" class="tcgb__chip" data-chip="'+e(x)+'" aria-pressed="'+(x===chip)+'">'+e(lab)+'</button>'}).join('')}

function pills(i,cls,px){var s=sd(i),o=op(i);
if(s.length<2)return px?'<div class="tcgb__opts"><span class="tcgb__card-single">'+(o.label?e(o.label)+' · ':'')+m(o.price)+'</span></div>':'';
return '<div class="'+cls+'">'+s.map(function(x){
return '<button type="button" class="tcgb__opt" data-opt="'+i.id+'" data-vid="'+x.id+'" aria-pressed="'+(String(x.id)===String(o.id))+'">'+e(x.label||'Option')+(px?'<b>'+m(x.price)+'</b>':'')+'</button>'}).join('')+'</div>'}

function flag(i){return i.pre?'<span class="tcgb__flag">Pre-order</span>':''}

function card(i,on,off){
return '<div class="tcgb__card'+(on?' is-on':'')+(off?' is-off':'')+'">'+flag(i)
+'<button type="button" class="tcgb__card-btn" data-pick="'+i.id+'"'+(off?' disabled':'')+' aria-label="'+e(i.title)+'">'
+(i.img?'<img class="tcgb__card-img" src="'+e(sz(i.img,500))+'" alt="" loading="lazy">':'<span class="tcgb__card-img"></span>')
+'<span class="tcgb__card-body"><span class="tcgb__card-name">'+e(i.title)+'</span></span></button>'
+'<span class="tcgb__card-tick" aria-hidden="true">&#10003;</span>'+pills(i,'tcgb__opts',1)
+(i.pre?'<span class="tcgb__card-pre">'+e(C.pl)+'</span>':'')
+(i.desc?'<button type="button" class="tcgb__more" data-more="'+i.id+'">Learn more</button>':'')+'</div>'}

function grid(){var l=A.filter(function(i){
if(chip!=='all'){
if(FMT[chip]){if(!hasFmt(i,chip))return false}
else if(grpOf(i.type)!==chip)return false}
if(term&&i.title.toLowerCase().indexOf(term)===-1)return false;return true});
el.g.innerHTML=l.length?l.map(function(i){var on=inJ(i.id);return card(i,on,!on&&full())}).join('')
:'<p class="tcgb__empty">Nothing matches.</p>'}

var deal=false;
function picker(list,kind){deal=false;
return '<div class="tcgb__picker">'+list.map(function(i){
var o=op(i),g=gf(i,o),on=kind==='ext'?inX(i.id):(mid&&String(mid.pid)===String(i.id));
var ch=kind==='ext'&&g&&done()&&g.price<o.price; if(ch)deal=true;
var xo=kind==='ext'&&!ch&&C.xoff>0;
var pr=ch?'<span class="tcgb__extra-was">'+m(o.price)+'</span> <span class="tcgb__extra-off">'+m(g.price)+'</span>'
:(xo?'<span class="tcgb__extra-was">'+m(o.price)+'</span> <span class="tcgb__extra-off">'+m(xDisc(o.price))+'</span>':m(o.price));
var sv=ch?(o.price-g.price):(xo?(o.price-xDisc(o.price)):0);
if(sv>0)pr+='<small class="tcgb__extra-save">Save '+m(sv)+'</small>';
var tag=xo?(Math.round(C.xoff*100)+'% off'):(ch?'Gift box price':'');
return '<div class="tcgb__pick'+(on?' is-on':'')+(tag?' has-tag':'')+'">'+flag(i)
+'<button type="button" class="tcgb__pick-btn" data-ppick="'+i.id+'" data-kind="'+kind+'">'
+(i.img?'<img src="'+e(sz(i.img,400))+'" alt="" loading="lazy">':'<span></span>')
+(tag?'<span class="tcgb__pick-tag">'+e(tag)+'</span>':'')
+'<span class="tcgb__pick-name">'+e(i.title)+'</span><span class="tcgb__pick-price">'+pr+'</span></button>'
+(i.pre?'<span class="tcgb__pick-pre">'+e(C.pl)+'</span>':'')
+pills(i,'tcgb__pick-opts',0)+'</div>'}).join('')+'</div>'}

function row(o,emp,k){return o
?'<li class="tcgb__slot-row is-filled">'+(o.img?'<img src="'+e(sz(o.img,120))+'" alt="">':'')
+'<span class="tcgb__slot-label">'+e(o.title)+'<small>'+(o.label?e(o.label)+' · ':'')+m(o.price)+(o.pre?' · '+e(C.pl):'')+'</small></span>'
+'<button type="button" class="tcgb__slot-x" data-rm="'+k+'" data-rmid="'+(o.pid||'')+'">&times;</button></li>'
:'<li class="tcgb__slot-row"><span class="tcgb__slot-label tcgb__slot-empty">'+e(emp)+'</span></li>'}

function draw(){var n=mx();sync();
el.jc.textContent=jars.length+' of '+n;
var r=[],i;for(i=0;i<n;i++)r.push(row(jars[i],'Jar '+(i+1)+' — empty','jar'));
if(ins==='two')r.push(row(mid,'Centrepiece — empty','mid'));
exs.forEach(function(x,j){r.push(row({pid:x.pid,vid:x.vid,title:x.title,label:x.label,price:xEff(x,j),img:x.img,pre:x.pre},'','ext'))});
if(wrap)r.push(row({title:'Gift wrapped',label:'',price:wp,img:wi},'','wrap'));
el.sl.innerHTML=r.join('');

var s=0;jars.forEach(function(j){s+=j.price});
if(ins==='two'&&mid)s+=mid.price;
exs.forEach(function(x,j){s+=xEff(x,j)});
if(wrap)s+=wp;
el.sb.textContent=s?m(s):'—';
var bval=(ins==='two'&&C.box2)?bv2:bv;
if(bval){el.sr.hidden=false;el.sv.textContent=m(bval);el.bx.textContent='Normally '+m(bval)+' — yours free'}
if(C.ship>0){el.sh.hidden=false;el.sf.style.width=Math.min(100,(s/C.ship)*100)+'%';
el.st.textContent=s>=C.ship?'Free shipping unlocked.':m(C.ship-s)+' away from free shipping.'}

var K=[];
if(ins==='two'&&M.length)K.push('<button type="button" class="tcgb__link" data-open="mid">'+(mid?'Change centrepiece':'Choose centrepiece')+'</button>');
if(X.length)K.push('<button type="button" class="tcgb__link" data-open="ext">'+(exs.length?'Edit extras':'Add an extra')+'</button>');
if(C.wv)K.push('<button type="button" class="tcgb__link" data-open="wrap">'+(wrap?'Remove gift wrap':'Add gift wrap')+'</button>');
el.lk.innerHTML=K.join('');

var nj=n-jars.length,nm=ins==='two'&&!mid;
var tx=nj>0?'Choose '+nj+' more jar'+(nj>1?'s':''):nm?'Choose your centrepiece':'Add gift box to cart · '+m(s);
el.cta.disabled=nj>0||nm;el.ct.textContent=tx;
if(el.bc){el.bc.disabled=nj>0||nm;el.bt.textContent=(nj>0||nm)?'Keep going':'Add to cart';
el.bi.innerHTML='<b>'+(s?m(s):'Your gift box')+'</b>'+e(tx)}
auto()}

function auto(){if(cur)return;
if(ins==='two'&&full()&&!mid&&!ma&&M.length){ma=true;setTimeout(function(){open('mid')},220);return}
if(done()&&!xa&&X.length){xa=true;setTimeout(function(){open('ext')},220);return}
if(done()&&!wa&&C.wv){wa=true;setTimeout(function(){open('wrap')},220)}}

function open(k,id){cur=k;var h='',cls='tcgb__modal-box';
if(k==='product'){var i=find(id);if(!i)return;
var o=op(i),mi=i.img2||i.img;if(mi)cls+=' has-img';
h=(mi?'<img class="tcgb__modal-img" src="'+e(sz(mi,700))+'" alt="">':'')
+'<div class="tcgb__modal-body"><h3 class="tcgb__modal-title">'+e(i.title)+'</h3>'
+'<p class="tcgb__modal-price">'+(o.label?e(o.label)+' · ':'')+m(o.price)+(i.pre?' · '+e(C.pl):'')+'</p>'
+'<div class="tcgb__modal-desc">'+i.desc+'</div><div class="tcgb__modal-actions">'
+'<button type="button" class="tcgb__modal-add" data-madd="'+i.id+'"'+((inJ(i.id)||full())?' disabled':'')+'>'
+(inJ(i.id)?'In your box':(full()?'Box is full':'Add to my box'))+'</button>'
+'<button type="button" class="tcgb__modal-close" data-close>Close</button></div></div>'}
if(k==='mid'){h='<div class="tcgb__modal-body"><h3 class="tcgb__modal-title">'+e(C.mt)+'</h3>'
+'<p class="tcgb__modal-price">'+e(C.ms)+'</p>'+picker(M,'mid')
+'<div class="tcgb__modal-actions"><button type="button" class="tcgb__modal-add" data-close'+(mid?'':' disabled')+'>'+e(C.mc)+'</button>'
+'<button type="button" class="tcgb__modal-close" data-close>'+e(C.mk)+'</button></div></div>'}
if(k==='ext'){var b=picker(X,'ext');
h='<div class="tcgb__modal-body"><h3 class="tcgb__modal-title">'+e(C.xt)+'</h3>'
+'<p class="tcgb__modal-price">'+e(C.xn)+'</p>'
+((deal||C.xoff>0)&&C.xbar?'<p class="tcgb__deal-bar">'+C.xbar+'</p>':'')+b
+((deal||C.xoff>0)&&C.xfine?'<p class="tcgb__modal-fine">'+e(C.xfine)+'</p>':'')
+'<div class="tcgb__modal-actions"><button type="button" class="tcgb__modal-add" data-close>'+e(C.xc)+'</button>'
+'<button type="button" class="tcgb__modal-close" data-close>'+e(C.xk)+'</button></div></div>'}
if(k==='wrap'){if(wi)cls+=' has-img';
h=(wi?'<img class="tcgb__modal-img" src="'+e(sz(wi,700))+'" alt="">':'')
+'<div class="tcgb__modal-body"><h3 class="tcgb__modal-title">'+e(C.wt)+'</h3>'
+'<p class="tcgb__wrap-note">'+e(C.wn)+'</p>'
+'<p class="tcgb__wrap-price">'+(wp?'+'+m(wp):'')+'</p>'
+'<div class="tcgb__modal-actions">'
+'<button type="button" class="tcgb__modal-add" data-wrap="1">'+e(C.wy)+'</button>'
+'<button type="button" class="tcgb__modal-close" data-wrap="0">'+e(C.wx)+'</button></div></div>'}
el.mb.className=cls;el.mb.innerHTML=h;el.mo.classList.add('is-open');document.body.style.overflow='hidden'}

function shut(){cur='';el.mo.classList.remove('is-open');document.body.style.overflow='';auto()}
if(el.mo)el.mo.addEventListener('click',function(v){if(v.target===el.mo)shut()});
document.addEventListener('keydown',function(v){if(v.key==='Escape'&&el.mo&&el.mo.classList.contains('is-open'))shut()});

root.addEventListener('click',function(v){
var t=v.target.closest('[data-insert],[data-chip],[data-pick],[data-opt],[data-rm],[data-more],[data-add],[data-close],[data-madd],[data-ppick],[data-open],[data-wrap]');
if(!t)return;
if(t.hasAttribute('data-insert')){ins=t.dataset.insert;ma=false;xa=false;
root.querySelectorAll('[data-insert]').forEach(function(b){var o=b===t;b.classList.toggle('is-selected',o);b.setAttribute('aria-pressed',o)});
while(jars.length>mx())jars.pop();if(ins==='three')mid=null;grid();draw();return}
if(t.hasAttribute('data-chip')){chip=t.dataset.chip;
root.querySelectorAll('[data-chip]').forEach(function(b){b.setAttribute('aria-pressed',b===t)});grid();return}
if(t.hasAttribute('data-opt')){v.preventDefault();v.stopPropagation();
var p=t.dataset.opt;pk[p]=t.dataset.vid;var a=find(p);
if(a){jars=jars.map(function(j){return String(j.pid)===String(p)?mk(a,op(a)):j});
if(cur==='mid')mid=mk(a,op(a));
else if(cur==='ext'){exs=exs.filter(function(x){return String(x.pid)!==String(p)});exs.push(mk(a,use(a)))}
else if(mid&&String(mid.pid)===String(p))mid=mk(a,op(a))}
if(cur==='mid'||cur==='ext')open(cur);else grid();draw();return}
if(t.hasAttribute('data-pick')){var it=find(t.dataset.pick);if(!it)return;
if(inJ(it.id))jars=jars.filter(function(j){return String(j.pid)!==String(it.id)});
else{if(full())return;jars.push(mk(it,op(it)))}
grid();draw();return}
if(t.hasAttribute('data-madd')){var z=find(t.dataset.madd);
if(z&&!inJ(z.id)&&!full())jars.push(mk(z,op(z)));shut();grid();draw();return}
if(t.hasAttribute('data-ppick')){var kd=t.dataset.kind,y=find(t.dataset.ppick);
if(y){if(kd==='ext'){if(inX(y.id))exs=exs.filter(function(x){return String(x.pid)!==String(y.id)});else exs.push(mk(y,use(y)))}
else mid=(mid&&String(mid.pid)===String(y.id))?null:mk(y,op(y))}
open(kd);draw();return}
if(t.hasAttribute('data-wrap')){wrap=t.dataset.wrap==='1';shut();draw();return}
if(t.hasAttribute('data-rm')){var k=t.dataset.rm,id=t.dataset.rmid;
if(k==='jar')jars=jars.filter(function(j){return String(j.pid)!==String(id)});
if(k==='mid')mid=null;
if(k==='ext')exs=exs.filter(function(x){return String(x.pid)!==String(id)});
if(k==='wrap')wrap=false;
grid();draw();return}
if(t.hasAttribute('data-open')){if(t.dataset.open==='wrap'&&wrap){wrap=false;draw();return}open(t.dataset.open);return}
if(t.hasAttribute('data-more')){open('product',t.dataset.more);return}
if(t.hasAttribute('data-close')){shut();draw();return}
if(t.hasAttribute('data-add')){add()}});

if(el.se)el.se.addEventListener('input',function(){term=this.value.trim().toLowerCase();grid()});
if(el.bc)el.bc.addEventListener('click',function(){add()});
look(C.box,function(v){bv=v.compare_at_price||0;draw()});
if(C.box2)look(C.box2,function(v){bv2=v.compare_at_price||0;draw()});
look(C.wv,function(v){wp=v.price;wi=(v.featured_image&&v.featured_image.src)||'';draw()});

function add(){el.er.hidden=true;el.cta.classList.add('is-busy');el.cta.disabled=true;
if(el.bc)el.bc.disabled=true;
var ly=ins==='three'?'3 jars':'2 jars + centrepiece',bx=boxV(),
no=(el.nt&&el.nt.value.trim())||'';
fetch('/cart.js',{headers:{Accept:'application/json'}})
.then(function(r){return r.ok?r.json():{items:[]}}).catch(function(){return {items:[]}})
.then(function(c){
var b=0;(c.items||[]).forEach(function(it){
var g=String((it.properties||{})['Gift box']||'').match(/^(\d+)/);
if(g&&parseInt(g[1],10)>b)b=parseInt(g[1],10)});
var sp=(b+1)+' · '+ly;
function P(r){var o={'Gift box':sp,'_layout':ly,'_role':r};if(anyPre())o['Dispatch']=C.pl;return o}
var Q=[];
jars.forEach(function(j){Q.push({id:j.vid,quantity:1,properties:P('In the box')})});
if(ins==='two'&&mid)Q.push({id:mid.vid,quantity:1,properties:P('Centrepiece')});
exs.forEach(function(x){Q.push({id:x.vid,quantity:1,properties:P('Extra')})});
if(wrap&&C.wv)Q.push({id:C.wv,quantity:1,properties:P('Gift wrap')});
if(bx){var bb=P('Gift box');if(no)bb['Gift note']=no;Q.push({id:bx,quantity:1,properties:bb})}
return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:Q})})
.then(function(r){return r.json().then(function(x){return {ok:r.ok,data:x}})})
.then(function(R){if(!R.ok)throw new Error(R.data.description||R.data.message||'Could not add to cart.');
window.location.href='/cart'})})
.catch(function(x){el.er.textContent=x.message;el.er.hidden=false;
el.cta.classList.remove('is-busy');el.cta.disabled=false;if(el.bc)el.bc.disabled=false})}

draw()}
function boot(){document.querySelectorAll('.tcgb').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();